// Omnix/client/widgets/UpcomingAppointmentsWidget.js
export default {
    name: "UpcomingAppointmentsWidget",
    type: "DataWidget",
    description: "Displays the user's upcoming calendar events for the next 7 days.",
    roles: ["user"],
    widget: {
        title: "Upcoming Appointments",
        size: "medium",
        dataProvider: {
            main: {
                rpc: "UserDashboardRpc.getMyUpcomingAppointments",
                params: {
                    start: "{{startDate}}",
                    end: "{{endDate}}"
                },
            }
        },
        fields: [
            // --- IMPROVEMENT: Better structure for date/time ---
            { 
                name: 'title', 
                isTitle: true 
            },
            { 
                name: 'start', 
                isSubtitle: true, 
                // Show time range (e.g., 10:00 AM - 11:00 AM)
                render: (val, item) => {
                    const startTime = val ? new Date(val).toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' }) : 'N/A';
                    const endTime = item.end ? new Date(item.end).toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' }) : '';
                    return `<i class="bi bi-clock-fill me-2 text-muted"></i> ${startTime}${endTime ? ` - ${endTime}` : ''}`;
                }
            },
            {
                name: 'start',
                isMeta: true,
                // Show the date (e.g., Sep 3, 2025)
                render: (val) => val ? new Date(val).toLocaleDateString([], { dateStyle: 'medium' }) : ''
            }
        ],
        noDataMessage: "No upcoming appointments."
    }
};